import { ContentSvg } from 'pdfmake/interfaces';

const checkboxContent = (): ContentSvg => {
  return {
    margin: [0, -1.5, 0, 0],
    width: 12,
    svg: '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9.75 2.75V10.25H2.25V2.75H9.75ZM10.125 2H1.875C1.66875 2 1.5 2.16875 1.5 2.375V10.625C1.5 10.8313 1.66875 11 1.875 11H10.125C10.3313 11 10.5 10.8313 10.5 10.625V2.375C10.5 2.16875 10.3313 2 10.125 2Z" fill="black"/> </svg>',
  };
};

const selectedCheckboxContent = (): ContentSvg => {
  return {
    margin: [0, -1.5, 0, 0],
    width: 12,
    svg: '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9.75 2.75V10.25H2.25V2.75H9.75ZM10.125 2H1.875C1.66875 2 1.5 2.16875 1.5 2.375V10.625C1.5 10.8313 1.66875 11 1.875 11H10.125C10.3313 11 10.5 10.8313 10.5 10.625V2.375C10.5 2.16875 10.3313 2 10.125 2Z" fill="black"/> <path d="M3 4C3 3.72386 3.22386 3.5 3.5 3.5H8.5C8.77614 3.5 9 3.72386 9 4V9C9 9.27614 8.77614 9.5 8.5 9.5H3.5C3.22386 9.5 3 9.27614 3 9V4Z" fill="black"/> </svg>',
  };
};

export { checkboxContent, selectedCheckboxContent };
